import { useSelector } from 'react-redux';

export const useArgSelector = (selector, ...args) => {
  return useSelector((state) => selector(state, ...args));
};
